var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"kt-switch",class:_vm._class},[_c('label',[_c('kt-input',{attrs:{"type":"checkbox","disabled":_vm.disabled}}),_vm._t("default"),_c('span')],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }